<a class="navbar-brand" style="float:left; padding: 0; height: 50px; display: flex; align-items: center; margin-left: 5px;">
    <img src="assets/OnreferenceLogoSVGOptimized.svg"
         alt="OnReference"
         style="height: 36px; width: auto; max-width: 160px;" />